
'use strict';
var app = angular.module('tf.services');
app.service('chartQuoteFeederService', ['$http', '$q', function($http, $q){

    var isoDateFormat = 'YYYY-MM-DD';
    var isoDateFormatWithTime = 'YYYY-MM-DDTHH:mm:ss';
    var max_periods = {
        day: moment.duration(600, 'd'),
        minute:  moment.duration(7, 'd'),
    };

    function getQuotesForChart(code, params, status) {
        if(status.fetching) {
            console.error('Abort because it is still fetching data');
            return $q.resolve([]);
        }

        status.fetching = true;

        return $http.get('/tradefloor/api/prices/chart/' + code, { params : params })
            .then( function(resp){
                status.fetching = false;
                var rows = Papa.parse(resp.data).data;
                rows.shift();
                var quotes = rows.filter(function (row) {
                    return row[0];
                })
                .map(function (row) {
                    return {
                        DT: new Date(row[0]),
                        //Date: moment(row[0]).format(isoDateFormat),
                        Open: parseFloat(row[1]),
                        High: parseFloat(row[2]),
                        Low: parseFloat(row[3]),
                        Close: parseFloat(row[4]),
                        IV30 : parseFloat(row[5]) * 100.0,
                        Volume : parseFloat(row[6])
                    }
                });
                return quotes;
            },
            function(resp){
                status.fetching = false;
                return resp;
            })

    }

    function fetchQuotes(code, fromDate, toDate, interval, period, status) {
        interval = (interval && max_periods[interval])? interval : 'day';
        var max_period = max_periods[interval];

        if(!toDate && fromDate) {  // it means, update mode.
            if(interval == 'minute') {
                toDate = moment(); // up to date now.
            } else {
                toDate = moment(fromDate).add(period, interval+"s");
            }
        }

        toDate = moment(toDate);
        if(fromDate) {
            fromDate = moment(fromDate);
            var earliest_fromDate = toDate.clone().subtract(max_period);
            if(earliest_fromDate.isAfter(fromDate)) {
                fromDate = earliest_fromDate;
            }
        } else {
            fromDate = toDate.clone().subtract(max_period);
        }

        var dateTimeFormat = interval == 'minute'? isoDateFormatWithTime: isoDateFormat;
        var params = {
            to: toDate.format(dateTimeFormat),
            from: fromDate.format(dateTimeFormat),
        };
        if (interval == 'minute') {
            params.i=period;
        }
        // just for debug
        {
            console.info('getting quote: '+ params.from + ' - ' + params.to + (params.i? ', i='+params.i: ''));
        }

        return getQuotesForChart(code, params, status);
    };


    this.getFeeder = function() {
        var status = {
            fetching: false,
        };
        var feeder = {

            // called by chart to fetch initial data
            fetchInitialData : function (symbol, suggestedStartDate, suggestedEndDate, params, cb) {

                if(!symbol) {
                    cb({error: 'No Symbol'});
                    return;
                }
                fetchQuotes(symbol, null, suggestedEndDate, params.interval, params.period, status).then(
                    function success(quotes) {
                        cb({quotes: quotes})
                    },
                    function failed(resp) {
                        cb({error: resp.status});
                    }
                );
            },

            // called by chart to fetch update data
            fetchUpdateData : function (symbol, startDate, params, cb) {

                var now = moment().tz('Australia/Sydney').hour();

                if (now > 17 || now < 10) {
                    cb({ quotes: [] });
                    return;
                }

                fetchQuotes(symbol, startDate, null, params.interval, params.period, status).then(
                    function success(quotes) {
                        cb({quotes: quotes})
                    },
                    function failed(resp) {
                        cb({error: resp.status});
                    }
                );
            },

            // called by chart to fetch pagination data
            fetchPaginationData : function (symbol, suggestedStartDate, endDate, params, cb) {
                fetchQuotes(symbol, suggestedStartDate, endDate, params.interval, params.period, status).then(
                    function success(quotes) {
                        cb({quotes: quotes})
                    },
                    function failed(resp) {
                        cb({error: resp.status});
                    }
                );
            }

        };
        return feeder;
    }
}]);

